<template>
  <div id="create-documents">
    <div class="page-title">
      <button @click="$router.go(-1)" class="back-button">
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
          <path d="M19 12H5" stroke="#1A1D1E" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
          <path d="M12 19L5 12L12 5" stroke="#1A1D1E" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
      </button>
      <h1>Criar documento</h1>
    </div>

    <section class="circular-radio" v-if="isFromAdminOrg">
      <h1><strong>Esse é um documento circular</strong> <span class="required">(obrigatório)</span></h1>
      <h2>Marcando sim você enviará para todos os usuários dos setores/gabinete</h2>
      <div class="radio-group">
        <label class="radio-label">
          <input type="radio" name="is-circular" :value="true" v-model="isCircularDoc" @change="onCircularChange">
          <span class="radio-custom"></span>
          <p>Sim</p>
        </label>
        <label class="radio-label">
          <input type="radio" name="is-circular" :value="false" v-model="isCircularDoc" @change="onCircularChange">
          <span class="radio-custom"></span>
          <p>Não</p>
        </label>
      </div>
    </section>

    <section>
      <h1><strong>Assunto</strong> (obrigatório)</h1>
      <MySelectFilter :name="'subject'" :value="documentSubjectSearch" v-model="documentSubjectSearch" @blur="verifyValueSubject">
        <li v-for="(subject, index) in documentSubjects" :key="index" @mousedown="selectedSubject = subject; documentSubjectSearch = subject.name;">{{ subject.name }}</li>
      </MySelectFilter>
    </section>
    <section class="exception" v-if="selectedSubject?.submission_end_day && (new Date().getDate() < selectedSubject?.submission_start_day || new Date().getDate() > selectedSubject?.submission_end_day)">
      <h1><strong>Exceção</strong> (obrigatório)</h1>
      <p>Esse documento está fora do prazo padrão de envio. Para enviar, marque como sendo uma exceção.</p>
      <label>
        <input type="radio" checked="true">
        <span></span>
        <p>Enviar como exceção</p>
      </label>
    </section>
    <section v-if="!isCircularDoc">
      <h1><strong>Tipo de documento?</strong> (obrigatório)</h1>
      <MySelect :name="'document_type'" :for="'document_type'" :currentValue="selectedDocumentType ? documentTypeTranslations[selectedDocumentType] : null">
        <li v-for="(type, index) in availableDocumentTypes" :key="index" @mousedown="onSelectDocumentType(type)">{{documentTypeTranslations[type]}}</li>
      </MySelect>
    </section>
    <section>
      <h1><strong>{{ isChamber ? 'Câmaras' : 'Setores/Gabinetes' }}</strong> (obrigatório)</h1>
      <h2 v-if="isCircular">Esta circular será enviada para todos os {{ isChamber ? 'câmaras' : 'setores/gabinetes' }} marcados abaixo. Desmarque aqueles que não devem receber.</h2>
      <h2 v-else>Quais {{ isChamber ? 'câmaras' : 'setores/gabinetes' }} irão ter acesso a esse documento? Você pode selecionar mais de um.</h2>
      <MyOptions :currentValue="selectedOrganizations.length ? `${selectedOrganizations.length} ${isChamber ? 'câmara(s)' : 'setor(es)'} selecionado(s)` : 'Selecione'">
        <div class="item" v-for="(organization, index) in organizations" :key="index">
          <input
            type="checkbox"
            :id="'organizations-' + index"
            :value="organization.id"
            :checked="selectedOrganizations.some((o) => o.id === organization.id)"
            @change="toggleOrganization(organization, ($event.target as HTMLInputElement).checked)"
          >
          <label :for="'organizations-' + index">
            <span>
              <svg xmlns="http://www.w3.org/2000/svg" width="13" height="10" viewBox="0 0 13 10" fill="none">
                <g clip-path="url(#clip0_388_3128)">
                  <path d="M12.3047 2.42188C12.3047 2.63021 12.2318 2.80729 12.0859 2.95312L6.42969 8.60938L5.36719 9.67188C5.22135 9.81771 5.04427 9.89062 4.83594 9.89062C4.6276 9.89062 4.45052 9.81771 4.30469 9.67188L3.24219 8.60938L0.414062 5.78125C0.268229 5.63542 0.195312 5.45833 0.195312 5.25C0.195312 5.04167 0.268229 5.86458 0.414062 4.71875L1.47656 3.65625C1.6224 3.51042 1.79948 3.4375 2.00781 3.4375C2.21615 3.4375 2.39323 3.51042 2.53906 3.65625L4.83594 5.96094L9.96094 0.828125C10.1068 0.682292 10.2839 0.609375 10.4922 0.609375C10.7005 0.609375 10.8776 0.682292 11.0234 0.828125L12.0859 1.89062C12.2318 2.03646 12.3047 2.21354 12.3047 2.42188Z"/>
                </g>
                <defs>
                  <clipPath id="clip0_388_3128">
                    <rect width="12.5" height="10" fill="white"/>
                  </clipPath>
                </defs>
              </svg>
            </span>
            <p>{{ organization.name }}</p>
          </label>
        </div>
      </MyOptions>
    </section>
    <section v-if="!isCircular">
      <h1><strong>Responsáveis</strong> (obrigatório)</h1>
      <h2>Quem irá ter acesso a esse documento? Você pode selecionar mais de uma pessoa.</h2>
      <MyOptions :currentValue="selectedResponsibles.length ? `${selectedResponsibles.length} responsável(is) selecionado(s)` : 'Selecione'">
        <div class="item" v-for="(responsible, index) in usersToTransfer" :key="index">
          <input
            type="checkbox"
            :id="'responsible-' + index"
            :value="responsible.id"
            :checked="selectedResponsibles.some((r) => r.id === responsible.id)"
            @change="toggleResponsible(responsible, ($event.target as HTMLInputElement).checked)"
          >
          <label :for="'responsible-' + index">
            <span>
              <svg xmlns="http://www.w3.org/2000/svg" width="13" height="10" viewBox="0 0 13 10" fill="none">
                <g clip-path="url(#clip0_388_3128)">
                  <path d="M12.3047 2.42188C12.3047 2.63021 12.2318 2.80729 12.0859 2.95312L6.42969 8.60938L5.36719 9.67188C5.22135 9.81771 5.04427 9.89062 4.83594 9.89062C4.6276 9.89062 4.45052 9.81771 4.30469 9.67188L3.24219 8.60938L0.414062 5.78125C0.268229 5.63542 0.195312 5.45833 0.195312 5.25C0.195312 5.04167 0.268229 4.86458 0.414062 4.71875L1.47656 3.65625C1.6224 3.51042 1.79948 3.4375 2.00781 3.4375C2.21615 3.4375 2.39323 3.51042 2.53906 3.65625L4.83594 5.96094L9.96094 0.828125C10.1068 0.682292 10.2839 0.609375 10.4922 0.609375C10.7005 0.609375 10.8776 0.682292 11.0234 0.828125L12.0859 1.89062C12.2318 2.03646 12.3047 2.21354 12.3047 2.42188Z"/>
                </g>
                <defs>
                  <clipPath id="clip0_388_3128">
                    <rect width="12.5" height="10" fill="white"/>
                  </clipPath>
                </defs>
              </svg>
            </span>
            <p>{{ responsible.name }} {{ responsible.last_name }}</p>
          </label>
        </div>
      </MyOptions>
    </section>
    <section>
      <h1><strong>Titulo desse documento</strong> (obrigatório)</h1>
      <h2>Dê um titulo claro para esse documento.</h2>
      <input type="text" placeholder="Ex: OFICIO 25 - SOLICITAÇÃO DE FALTAS" name="title-document" id="title-document" v-model="title">
    </section>
    <section>
      <h1><strong>{{ isChamber ? 'Número de documento' : 'Número do ofício ou portaria' }}</strong> (obrigatório)</h1>
      <h2>Adicione esse número para facilitar a organização no sistema.</h2>
      <input type="text" placeholder="Ex: 1011" name="title-document" id="title-document" v-model="physicalDocumentNumber">
    </section>
    <section>
      <h1><strong>Data limite</strong> (obrigatório)</h1>
      <h2>Prazo máximo para o documento ser apreciado.</h2>
      <label class="date-picker-label" for="date-limit-document" @click="isDatePickerModalOpen = true;">
        <input type="text" placeholder="Selecione uma data" name="date-limit-document" id="date-limit-document" :value="formattedLimitDate ? formattedLimitDate : ''" readonly>
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
          <path d="M8 2V5" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
          <path d="M16 2V5" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
          <path d="M3.5 9.08984H20.5" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
          <path d="M21 8.5V17C21 20 19.5 22 16 22H8C4.5 22 3 20 3 17V8.5C3 5.5 4.5 3.5 8 3.5H16C19.5 3.5 21 5.5 21 8.5Z" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
          <path d="M15.6937 13.7002H15.7027" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
          <path d="M15.6937 16.7002H15.7027" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
          <path d="M11.9945 13.7002H12.0035" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
          <path d="M11.9945 16.7002H12.0035" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
          <path d="M8.29529 13.7002H8.30427" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
          <path d="M8.29529 16.7002H8.30427" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
      </label>
    </section>
    <section class="content-section">
      <div class="content-section__header">
        <div>
          <h1><strong>Conteúdo desse documento</strong> (obrigatório)</h1>
          <h2>Descreva os principais detalhes que irão ajudar aos interessados saber sobre o documento.</h2>
        </div>
        <button v-if="hasAiModule" type="button" class="ai-toggle-button" @click="isAiPanelOpen = !isAiPanelOpen">
          <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none">
            <path d="M12 3L13.7 8.3L19 10L13.7 11.7L12 17L10.3 11.7L5 10L10.3 8.3L12 3Z" fill="currentColor"/>
            <path d="M19 15L19.8 17.2L22 18L19.8 18.8L19 21L18.2 18.8L16 18L18.2 17.2L19 15Z" fill="currentColor"/>
          </svg>
          Gerar com IA
        </button>
      </div>
      <div class="ai-panel" v-if="hasAiModule && isAiPanelOpen">
        <label for="ai-prompt">Descreva o que esse documento deve conter e a IA escreve um rascunho para você</label>
        <textarea id="ai-prompt" v-model="aiPrompt" rows="3" placeholder="Ex: Um ofício solicitando a liberação de verba para reforma da escola municipal, com prazo de resposta de 15 dias."></textarea>
        <div class="ai-panel__footer">
          <span class="ai-panel__quota" v-if="aiUsage">{{ aiUsage.remaining }} de {{ aiUsage.limit }} gerações restantes hoje</span>
          <input
            v-if="!isGeneratingAiContent"
            type="button"
            value="Gerar conteúdo"
            :disabled="!aiPrompt.trim() || (aiUsage && aiUsage.remaining <= 0)"
            @click="generateAiContent"
          >
          <SpinnerLoaderButton v-else :height="40" :maxWidth="160" />
        </div>
      </div>
      <!-- <textarea class="text" v-model="content"></textarea> -->
      <TextEditor :value="content" :setValue="(value) => content = value" />
      <div class="ai-compliance" v-if="hasAiModule">
        <button type="button" class="ai-toggle-button" :disabled="!content || isReviewingCompliance" @click="reviewCompliance">
          <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none">
            <path d="M12 3L13.7 8.3L19 10L13.7 11.7L12 17L10.3 11.7L5 10L10.3 8.3L12 3Z" fill="currentColor"/>
            <path d="M19 15L19.8 17.2L22 18L19.8 18.8L19 21L18.2 18.8L16 18L18.2 17.2L19 15Z" fill="currentColor"/>
          </svg>
          {{ isReviewingCompliance ? 'Revisando...' : 'Revisar formalidades com IA' }}
        </button>
        <div class="ai-compliance__result" v-if="complianceResult">
          <p class="ai-compliance__ok" v-if="complianceResult.ok">Nenhuma formalidade pendente encontrada.</p>
          <ul class="ai-compliance__issues" v-else>
            <li v-for="(issue, index) in complianceResult.issues" :key="index">{{ issue }}</li>
          </ul>
        </div>
      </div>
    </section>
    <section>
      <h1><strong>Palavras chaves</strong> (opcional)</h1>
      <h2>Separe por vírgula, exemplo: férias, pagamento.</h2>
      <MyTags v-model="keywords" :name="'keywords'" :placeholder="'Digite a palavra chave'"/>
    </section>
    <section>
      <h1><strong>Arquivo do documento</strong> (opcional)</h1>
      <h2>Adicione um arquivo a esse documento, podendo ser DOC ou PDF.</h2>
      <FileUploader :files="documentFiles" :pushFile="(file) => documentFiles.push(file)" />
      <div class="ai-classify" v-if="hasAiModule && documentFiles.length">
        <button type="button" class="ai-toggle-button" :disabled="isClassifyingFiles" @click="classifyFilesWithAi">
          <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none">
            <path d="M12 3L13.7 8.3L19 10L13.7 11.7L12 17L10.3 11.7L5 10L10.3 8.3L12 3Z" fill="currentColor"/>
            <path d="M19 15L19.8 17.2L22 18L19.8 18.8L19 21L18.2 18.8L16 18L18.2 17.2L19 15Z" fill="currentColor"/>
          </svg>
          {{ isClassifyingFiles ? 'Analisando arquivos...' : 'Preencher automaticamente com IA' }}
        </button>
        <span class="ai-classify__hint">A IA lê os arquivos anexados e sugere assunto, tipo, palavras-chave e citados.</span>
      </div>
    </section>
    <section class="spacing">
      <h1><strong>Citado(s) no(s) documento(s)</strong> (opcional)</h1>
      <h2>Escreva nome e sobrenome dos participantes citados no(s) anexo(s) e separe por vírgula.</h2>
      <MyTags v-model="mentions" :name="'mentions'" :placeholder="'Digite nome e sobrenome'"/>
    </section>
    <nav>
      <input v-if="!isCreatingDocument" type="button" value="Enviar" @click="createDocument" :disabled="!selectedSubject || !selectedDocumentType || !selectedOrganizations.length || (!isCircular && !selectedResponsibles.length) || !title || !physicalDocumentNumber || !limitDate || !content">
      <SpinnerLoaderButton v-else :height="60" :maxWidth="464" />
      <input type="button" value="Cancelar" @click="$router.go(-1)">
    </nav>
    <MyModal :width="'341px !important'" :height="'517px !important'" :className="'date-limit'" :isOpen="isDatePickerModalOpen" :toggleModal="(v: boolean) => isDatePickerModalOpen = v" :zIndex="100">
      <div class="modal-date-title">
        <h1>Data limite</h1>
        <h2>Prazo máximo para ser aceito.</h2>
      </div>
      <MyDatePicker :min="{ day: new Date().getDate(), month: new Date().getMonth() + 1, year: new Date().getFullYear() }" :name="'limit'" :setValue="(date) => selectedLimitDate = date"/>
      <input type="button" value="Aplicar data" @click="limitDate = selectedLimitDate; isDatePickerModalOpen = false">
    </MyModal>
    <MyModal :width="'330px !important'" :height="'179px !important'" :isOpen="isCreateDocumentModalOpen" :class-name="'confirm-create-document'" :toggleModal="(v: boolean) => isCreateDocumentModalOpen = v" :zIndex="100">
      <div>
        <svg xmlns="http://www.w3.org/2000/svg" width="52" height="52" viewBox="0 0 52 52" fill="none">
          <path d="M18.1787 40.0616V18.0482C18.1787 17.1816 18.4387 16.3366 18.9154 15.6216L24.8304 6.82491C25.762 5.41657 28.0804 4.41991 30.052 5.15657C32.1754 5.87157 33.5837 8.2549 33.1287 10.3782L32.002 17.4632C31.9154 18.1132 32.0887 18.6982 32.457 19.1532C32.8254 19.5649 33.367 19.8249 33.952 19.8249H42.857C44.5687 19.8249 46.042 20.5182 46.9087 21.7316C47.732 22.9016 47.8837 24.4182 47.342 25.9566L42.012 42.1849C41.3404 44.8716 38.4154 47.0599 35.512 47.0599H27.062C25.6104 47.0599 23.5737 46.5616 22.642 45.6299L19.8687 43.4849C18.807 42.6832 18.1787 41.4049 18.1787 40.0616Z" fill="#05CB95"/>
          <path d="M11.288 13.8232H9.05634C5.69801 13.8232 4.33301 15.1232 4.33301 18.3299V40.1266C4.33301 43.3332 5.69801 44.6332 9.05634 44.6332H11.288C14.6463 44.6332 16.0113 43.3332 16.0113 40.1266V18.3299C16.0113 15.1232 14.6463 13.8232 11.288 13.8232Z" fill="#05CB95"/>
        </svg>
        <h1>Tudo certo!</h1>
        <h2>Documento enviado com sucesso.</h2>
      </div>
    </MyModal>
  </div>
</template>

<script setup lang="ts">
import { computed, onMounted, ref } from 'vue'
import { toast } from 'vue3-toastify'
import MyModal from '@/components/modal/MyModal.vue'
import MyDatePicker from '@/components/date/MyDatePicker.vue'
import MySelect from '@/components/select/MySelect.vue'
import MySelectFilter from '@/components/select/MySelectFilter.vue'
import MyTags from '@/components/tag/MyTags.vue'
import MyOptions from '@/components/options/MyOptions.vue'
import DocumentTypeEnum, { documentTypeTranslations } from '@/enums/DocumentTypeEnum'
import { OrganizationModel } from '@/models/OrganizationModel'
import { useAxios } from '@/api/axios'
import { UserModel } from '@/models/UserModel'
import TextEditor from '@/components/input/TextEditor.vue'
import FileUploader from '@/components/input/FileUploader.vue'
import DocumentSubjectModel from '@/models/DocumentSubjectModel'
import SpinnerLoaderButton from '@/components/loader/SpinnerLoaderButton.vue'
import DocumentTagTypeEnum from '@/enums/DocumentTags/DocumentTagTypeEnum'
import { user as authenticatedUser, hasAiModule } from '@/global/states/GlobalState'
import { TenantSectorEnum } from '@/enums/Tenants/TenantSectorEnum'

const axios = useAxios()
const isChamber = computed(() => authenticatedUser.value.tenant?.sector === TenantSectorEnum.CHAMBER)
const isFromAdminOrg = computed(() => users.value?.some((user) =>
  user.organization_id === authenticatedUser.value.organization_id &&
  user.roles?.some((role) => role.name === 'Super Admin' || role.name === 'Presidente')
))
const availableDocumentTypes = computed(() => {
  return (Object.values(DocumentTypeEnum) as DocumentTypeEnum[]).filter((type) => {
    return type !== DocumentTypeEnum.CIRCULAR
  })
})
const organizations = ref<OrganizationModel[]>()
const users = ref<UserModel[]>([])
const usersToTransfer = computed(() => users.value?.filter((user) => (selectedOrganizations.value.length ? selectedOrganizations.value.some((o) => o.id === user.organization_id) : true) &&
user.status === 'active'))
const documentSubjects = computed(() => {
    return documentSubjectsInitial.value?.filter(
      subject =>
        subject.name.toLowerCase().includes(documentSubjectSearch.value.toLowerCase())
    )
})
const documentSubjectsInitial = ref<DocumentSubjectModel[]>()
const isCreatingDocument = ref(false)
const documentSubjectSearch = ref('')

/* FORM */
const isCircularDoc = ref<boolean>(false)

function onCircularChange(): void {
  if (isCircularDoc.value) {
    onSelectDocumentType(DocumentTypeEnum.CIRCULAR)
  } else {
    selectedDocumentType.value = undefined
    selectedOrganizations.value = []
  }
}

const selectedSubject = ref<DocumentSubjectModel>()
const selectedDocumentType = ref<DocumentTypeEnum>()
const selectedOrganizations = ref<OrganizationModel[]>([])
const selectedResponsibles = ref<UserModel[]>([])
const isCircular = computed(() => selectedDocumentType.value === DocumentTypeEnum.CIRCULAR)
const title = ref<string>('')
const physicalDocumentNumber = ref<string>('')
const content = ref<string>('')
const documentFiles = ref<File[]>([])
const selectedLimitDate = ref('')
const limitDate = ref('')
const formattedLimitDate = computed(() => limitDate.value ? formatDate(limitDate.value) : undefined)
const mentions = ref<string[]>([])
const keywords = ref<string[]>([])
/* FORM */

/* AI COMPLIANCE REVIEW */
const isReviewingCompliance = ref<boolean>(false)
const complianceResult = ref<{ ok: boolean, issues: string[] }>()

function reviewCompliance (): void {
  if (!content.value || isReviewingCompliance.value) return

  isReviewingCompliance.value = true

  const body = new FormData()
  body.append('content', content.value)
  if (selectedDocumentType.value) body.append('type', selectedDocumentType.value as string)

  axios.post('/api/documents/ai-review-compliance', body)
    .then((res) => {
      complianceResult.value = res.data
    })
    .catch((error) => {
      if (!error?.response?.data?.errors) {
        toast.error('Não foi possível revisar o documento com IA. Tente novamente.')
      }
    })
    .finally(() => {
      isReviewingCompliance.value = false
      getAiContentUsage()
    })
}
/* AI COMPLIANCE REVIEW */

/* AI FILE CLASSIFICATION */
const isClassifyingFiles = ref<boolean>(false)

function classifyFilesWithAi (): void {
  if (!documentFiles.value.length || isClassifyingFiles.value) return

  isClassifyingFiles.value = true

  const payload = new FormData()
  documentFiles.value.forEach((file) => payload.append('files[]', file))

  axios.post('/api/documents/ai-classify-content', payload)
    .then((res) => {
      const suggestion = res.data

      if (suggestion.document_subject_id) {
        const subject = documentSubjectsInitial.value?.find((s) => s.id === suggestion.document_subject_id)
        if (subject) {
          selectedSubject.value = subject
          documentSubjectSearch.value = subject.name
        }
      }

      if (suggestion.type && !isCircularDoc.value) {
        onSelectDocumentType(suggestion.type)
      }

      if (suggestion.keywords?.length) {
        keywords.value = Array.from(new Set([...keywords.value, ...suggestion.keywords]))
      }

      if (suggestion.mentions?.length) {
        mentions.value = Array.from(new Set([...mentions.value, ...suggestion.mentions]))
      }

      toast.success('A IA preencheu os campos com base nos arquivos. Revise antes de enviar.')
    })
    .catch((error) => {
      if (!error?.response?.data?.errors) {
        toast.error('Não foi possível classificar os arquivos com IA. Tente novamente.')
      }
    })
    .finally(() => {
      isClassifyingFiles.value = false
      getAiContentUsage()
    })
}
/* AI FILE CLASSIFICATION */

/* AI CONTENT GENERATION */
const isAiPanelOpen = ref<boolean>(false)
const aiPrompt = ref<string>('')
const isGeneratingAiContent = ref<boolean>(false)
const aiUsage = ref<{ limit: number, used: number, remaining: number }>()

function getAiContentUsage (): void {
  axios.get('/api/documents/ai-generate-content/usage')
    .then((res) => {
      aiUsage.value = res.data
    })
}

function generateAiContent (): void {
  if (!aiPrompt.value.trim() || isGeneratingAiContent.value) return

  isGeneratingAiContent.value = true

  const payload = new FormData()
  payload.append('prompt', aiPrompt.value.trim())
  if (title.value) payload.append('title', title.value)
  if (selectedSubject.value?.name) payload.append('document_subject', selectedSubject.value.name)
  if (selectedDocumentType.value) payload.append('type', selectedDocumentType.value as string)

  axios.post('/api/documents/ai-generate-content', payload)
    .then((res) => {
      content.value = res.data.content
      aiPrompt.value = ''
      isAiPanelOpen.value = false
    })
    .catch((error) => {
      if (!error?.response?.data?.errors) {
        toast.error('Não foi possível gerar o conteúdo com IA. Tente novamente.')
      }
    })
    .finally(() => {
      isGeneratingAiContent.value = false
      getAiContentUsage()
    })
}
/* AI CONTENT GENERATION */

const isDatePickerModalOpen = ref<boolean>(false)
const isCreateDocumentModalOpen = ref<boolean>(false)

const verifyValueSubject = (value: string) => {
  if (documentSubjectsInitial.value) {
    let onClear = false
    for (const [index, options] of documentSubjectsInitial.value.entries()) {
      if (options.name == value) {
        onClear = true
      }
    }
    if (!onClear) {
      documentSubjectSearch.value = ''
      selectedSubject.value = undefined
    }
  }
}

const formatDate = (date: string) => {
  const [year, mouth, day] = date.split('-')
  return `${day}/${mouth}/${year}`
}

function onSelectDocumentType (type: DocumentTypeEnum): void {
  selectedDocumentType.value = type
  if (type === DocumentTypeEnum.CIRCULAR) {
    selectedOrganizations.value = organizations.value ? [...organizations.value] : []
    selectedResponsibles.value = []
  } else {
    selectedOrganizations.value = []
    selectedResponsibles.value = []
  }
}

function toggleOrganization (organization: OrganizationModel, checked: boolean): void {
  if (checked) {
    if (!selectedOrganizations.value.some((o) => o.id === organization.id)) {
      selectedOrganizations.value.push(organization)
    }
  } else {
    selectedOrganizations.value = selectedOrganizations.value.filter((o) => o.id !== organization.id)
    selectedResponsibles.value = selectedResponsibles.value.filter((r) => r.organization_id !== organization.id)
  }
}

function toggleResponsible (responsible: UserModel, checked: boolean): void {
  if (checked) {
    if (!selectedResponsibles.value.some((r) => r.id === responsible.id)) {
      selectedResponsibles.value.push(responsible)
    }
  } else {
    selectedResponsibles.value = selectedResponsibles.value.filter((r) => r.id !== responsible.id)
  }
}

function createDocument (): void {
  isCreatingDocument.value = true

  const payload = new FormData()
  payload.append('document_subject_id', String(selectedSubject.value!.id))
  payload.append('type', selectedDocumentType.value as string)
  const orgIds = selectedOrganizations.value.map((org) => org.id)
  orgIds.forEach((id) => {
    payload.append('organization_ids[]', String(id))
  })
  if (isCircular.value) {
    const responsibleIds = users.value
      .filter((u) => u.status === 'active' && u.organization_id && orgIds.includes(u.organization_id))
      .map((u) => u.id)
    responsibleIds.forEach((id) => {
      payload.append('user_ids[]', String(id))
    })
  } else {
    selectedResponsibles.value.forEach((responsible) => {
      payload.append('user_ids[]', String(responsible.id))
    })
  }
  payload.append('title', title.value)
  payload.append('physical_document_number', physicalDocumentNumber.value)
  payload.append('limit_date', limitDate.value)
  payload.append('content', content.value)
  for (const key in documentFiles.value) {
    payload.append('files[]', documentFiles.value[key])
  }
  let tagsIndex = 0
  const appendTags = (items: string[], type: DocumentTagTypeEnum) => {
    items.forEach((item) => {
      payload.append(`tags[${tagsIndex}][title]`, item)
      payload.append(`tags[${tagsIndex}][type]`, type)
      tagsIndex++
    })
  }

  appendTags(mentions.value, DocumentTagTypeEnum.MENTION)
  appendTags(keywords.value, DocumentTagTypeEnum.KEYWORD)

  axios.post('/api/documents', payload)
    .then(() => {
      isCreateDocumentModalOpen.value = true
      resetForm()
    })
    .finally(() => isCreatingDocument.value = false)
}

function resetForm (): void {
  isCircularDoc.value = false
  documentSubjectSearch.value = ''
  selectedSubject.value = undefined
  selectedDocumentType.value = undefined
  selectedOrganizations.value = []
  selectedResponsibles.value = []
  title.value = ''
  physicalDocumentNumber.value = ''
  limitDate.value = ''
  content.value = ''
  documentFiles.value = []
  mentions.value = []
  keywords.value = []
  selectedLimitDate.value = ''
}

function getOrganizations () {
  axios.get('/api/organizations')
    .then((res) => {
      organizations.value = res.data
    })
}

function getUsers () {
  axios.get('/api/users')
    .then((res) => {
      users.value = res.data
    })
}

function getDocumentSubjects () {
  axios.get('/api/document-subjects', { params: { status: 'active' } })
    .then((res) => {
      documentSubjectsInitial.value = res.data
    })
}

onMounted(() => {
  getOrganizations()
  getUsers()
  getDocumentSubjects()
  getAiContentUsage()
})
</script>

<style lang="scss">
  #create-documents{
    width: 100%;
    max-width: 1200px;
    display: flex;
    flex-direction: column;
    align-items: start;
    row-gap: 28px;
    padding: 32px 0 0 0;

    .page-title {
      display: flex;
      align-items: center;
      gap: 16px;
      margin-bottom: 8px;
      .back-button {
        display: flex;
        align-items: center;
        justify-content: center;
        width: 40px;
        height: 40px;
        border-radius: 50%;
        border: none;
        background: #F1F1F1;
        cursor: pointer;
        transition: background .2s;
        &:hover {
          background: #E5E5E5;
        }
      }
      h1 {
        color: #090909;
        font-family: 'Nunito', sans-serif;
        font-size: 24px;
        font-style: normal;
        font-weight: 700;
        line-height: normal;
        margin: 0;
      }
    }

    .circular-radio {
      .required {
        font-weight: 400;
        font-size: 14px;
        color: #6F6F6F;
      }
      .radio-group {
        display: flex;
        align-items: center;
        gap: 24px;
        margin-top: 15px;
        .radio-label {
          display: flex;
          align-items: center;
          column-gap: 8px;
          cursor: pointer;
          input {
            display: none;
            &:checked {
              & ~ .radio-custom {
                border-color: $fluxoo-primary-color;
                outline: 1px solid $fluxoo-primary-color;
                &::before {
                  transform: scale(1.0);
                  opacity: 1;
                }
              }
              & ~ p {
                color: $fluxoo-primary-color;
              }
            }
          }
          .radio-custom {
            display: flex;
            align-items: center;
            justify-content: center;
            width: 20px;
            min-width: 20px;
            height: 20px;
            min-height: 20px;
            border-radius: 50%;
            border: 1px solid #D5D5D5;
            transition: border-color .2s;
            &::before {
              content: '';
              width: 10px;
              min-width: 10px;
              height: 10px;
              min-height: 10px;
              border-radius: 50%;
              background: $fluxoo-primary-color;
              transform: scale(0.0);
              opacity: 0;
              transition: transform .2s, opacity .1s;
            }
          }
          p {
            color: #949494;
            font-family: 'Inter', sans-serif;
            font-size: 16px;
            font-style: normal;
            font-weight: 500;
            line-height: 17px;
            margin: 0;
            transition: color .2s;
          }
        }
      }
    }

    section{
      width: 100%;
      display: flex;
      flex-direction: column;
      h1{
        color: #090909;
        font-family: 'Inter', sans-serif;
        font-size: 14px;
        font-style: normal;
        font-weight: 400;
        line-height: normal;
        margin: 0 0 13px 0;
        text-align: start;
        strong{
          color: #090909;
          font-family: 'Inter', sans-serif;
          font-size: 20px;
          font-style: normal;
          font-weight: 700;
          line-height: normal;
        }
      }
      h2{
        color: #6F6F6F;
        font-family: 'Inter', sans-serif;
        font-size: 14px;
        font-style: normal;
        font-weight: 400;
        line-height: normal;
        text-align: start;
        margin: -13px 0 13px 0;
      }
      input[type="text"]{
        width: 100%;
        height: 55px;
        border-radius: 14px;
        border: 1px solid #D3D3D3;
        color: $fluxoo-primary-color;
        font-family: 'Inter', sans-serif;
        font-size: 16px;
        font-style: normal;
        font-weight: 400;
        line-height: normal;
        padding: 15px 20px;
        box-sizing: border-box;
        transition: border-color .2s, color .2s, background .2s;
        &:focus{
          outline: none;
        }
        &::placeholder{
          color: #090909;
          font-family: 'Inter', sans-serif;
          font-size: 16px;
          font-style: normal;
          font-weight: 400;
          line-height: normal;
          transition: color .2s;
        }
      }
      label.check{
        input{
          display: none;
          &:checked ~ span{
            background: $fluxoo-primary-color;
            border-color: $fluxoo-primary-color;
          }
        }
        span{
          display: flex;
          align-items: center;
          justify-content: center;
          width: 24px;
          min-width: 24px;
          height: 24px;
          min-height: 24px;
          border-radius: 8px;
          border: 1px solid #6F6F6F;
          transition: border-color .2s, background .2s;
          cursor: pointer;
        }
      }
      .date-picker-label{
        position: relative;
        display: flex;
        align-items: center;
        input{
          cursor: pointer;
          color: $fluxoo-primary-color;
        }
        svg{
          width: 24px;
          min-width: 24px;
          height: 24px;
          min-height: 24px;
          stroke: #090909;
          position: absolute;
          right: 22px;
        }
      }
    }
    .exception{
      background: #EDF5F3;
      padding: 20px;
      border-radius: 18px;
      box-sizing: border-box;
      h1{
        margin: 0
      }
      p{
        color: var(--cinza-forte, #6F6F6F);
        font-family: Inter;
        font-size: 0.875rem;
        font-style: normal;
        font-weight: 400;
        margin: 0;
      }
      label{
        display: flex;
        align-items: center;
        column-gap: 8px;
        margin-top:.94rem;
        cursor: pointer;
        input{
          display: none;
          &:checked{
            & ~ span{
              border-color: $fluxoo-primary-color;
              outline: 1px solid $fluxoo-primary-color;
              &::before{
                transform: scale(1.0);
                opacity: 1;
              }
            }
            & ~ p{
              color: $fluxoo-primary-color;
            }
          }
        }
        span{
          width: 24px;
          min-width: 24px;
          height: 24px;
          min-height: 24px;
          border-radius: 50%;
          border: 1px solid #D5D5D5;
          position: relative;
          transition: border-color .2s;
          &::before{
            content: '';
            width: 12px;
            min-width: 12px;
            height: 12px;
            min-height: 12px;
            border-radius: 50%;
            background: $fluxoo-primary-color;
            position: absolute;
            top: 6px;
            left: 6px;
            transform: scale(0.0);
            opacity: 0;
            transition: transform .2s, opacity .1s;
          }
        }
        p{
          color: #949494;
          font-family: 'Inter', sans-serif;
          font-size: 16px;
          font-style: normal;
          font-weight: 500;
          line-height: 17px;
          margin: 0;
          transition: color .2s;
        }
      }
    }
    nav{
      width: 100%;
      max-width: 1200px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding: 15px 32px;
      border-radius: 16px;
      background: #FFF;
      box-shadow: 0px 0px 25px 0px rgba(0, 0, 0, 0.12);
      box-sizing: border-box;
      position: sticky;
      bottom: 5px;
      column-gap: 20px;
      input{
        border: none;
        cursor: pointer;
        &:first-child{
          width: 100%;
          max-width: 464px;
          height: 60px;
          border-radius: 30px;
          background: $fluxoo-primary-color;
          color: #FFF;
          text-align: center;
          font-family: 'Inter', sans-serif;
          font-size: 16px;
          font-style: normal;
          font-weight: 600;
          line-height: normal;
          transition: background .2s;
          &:hover{
            background: $fluxoo-primary-color-hover;
          }
        }
        &:last-child{
          color: #737373;
          font-family: 'Inter', sans-serif;
          font-size: 16px;
          font-style: normal;
          font-weight: 600;
          line-height: normal;
          background: unset;
          transition: color .2s;
          &:hover{
            color: $fluxoo-primary-color;
          }
        }
      }
    }
    .modal{
      &.date-limit{
        .modal__content{
          padding: 15px 28px;
          box-sizing: border-box;
          overflow-y: auto;
          &::-webkit-scrollbar{
            width: 0;
          }
          button{
            display: flex;
            top: 26px;
            right: 28px;
          }
          .modal-date-title{
            padding: 0;
            display: flex;
            flex-direction: column;
            align-items: start;
            margin: 0 0 25px 0;
            h1{
              color: #090909;
              font-family: 'Nunito', sans-serif;
              font-size: 32px;
              font-style: normal;
              font-weight: 800;
              line-height: normal;
              text-align: start;
              margin: 0;
            }
            h2{
              color: #6F6F6F;
              font-family: 'Inter', sans-serif;
              font-size: 14px;
              font-style: normal;
              font-weight: 400;
              line-height: 2px;
              text-align: start;
              margin: 0;
            }
          }
          input[type='button']{
            width: 100%;
            min-height: 55px;
            border-radius: 30px;
            border: none;
            background: $fluxoo-primary-color;
            color: #FFF;
            text-align: center;
            font-family: 'Inter', sans-serif;
            font-size: 16px;
            font-style: normal;
            font-weight: 600;
            line-height: normal;
            margin: 8px 0 0 0;
            transition: background .2s;
            cursor: pointer;
            &:disabled{
              background: #F1F1F1 !important;
              color: #6F6F6F !important;
              cursor: not-allowed !important;
            }
            &:hover{
              background: $fluxoo-primary-color-hover;
            }
          }
        }
      }
      &.confirm-create-document{
        div{
          div{
            display: flex;
            flex-direction: column;
            align-items: center;
            padding: 26px 15px 0;
            h1{
              color: #090909;
              font-family: 'Nunito', sans-serif;
              font-size: 28px;
              font-style: normal;
              font-weight: 900;
              line-height: normal;
              margin: 2px 0 7px 0;
            }
            h2{
              color: #6F6F6F;
              text-align: center;
              font-family: 'Inter', sans-serif;
              font-size: 15px;
              font-style: normal;
              font-weight: 400;
              line-height: normal;
              margin: 0;
            }
          }
        }
        button{
          display: flex;
          top: 28px;
          right: 28px;
        }
      }
    }
  }

  /* Estilos globais compartilhados pelas funcionalidades de IA (usados também fora deste componente,
     em ViewDocument.vue, CreateModelsView.vue e EditModelView.vue). */
  .content-section{
    &__header{
      width: 100%;
      display: flex;
      align-items: flex-start;
      justify-content: space-between;
      gap: 16px;
      h1, h2{
        margin: 0 0 13px 0;
      }
    }
  }
  .ai-toggle-button{
    display: flex;
    align-items: center;
    column-gap: 6px;
    flex-shrink: 0;
    height: 38px;
    padding: 0 16px;
    border: none;
    border-radius: 30px;
    background: #EDF5F3;
    color: $fluxoo-primary-color;
    font-family: 'Inter', sans-serif;
    font-size: 14px;
    font-weight: 600;
    white-space: nowrap;
    cursor: pointer;
    transition: background .2s;
    &:hover{
      background: darken(#EDF5F3, 4%);
    }
    &:disabled{
      opacity: .6;
      cursor: not-allowed;
    }
  }
  .ai-classify{
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    column-gap: 12px;
    row-gap: 6px;
    margin-top: 14px;
    &__hint{
      color: #6F6F6F;
      font-family: 'Inter', sans-serif;
      font-size: 13px;
    }
  }
  .ai-compliance{
    display: flex;
    flex-direction: column;
    row-gap: 12px;
    margin-top: 14px;
    &__result{
      background: #EDF5F3;
      border-radius: 18px;
      padding: 16px 20px;
      box-sizing: border-box;
    }
    &__ok{
      color: #05CB95;
      font-family: 'Inter', sans-serif;
      font-size: 14px;
      font-weight: 600;
      margin: 0;
      text-align: start;
    }
    &__issues{
      margin: 0;
      padding: 0 0 0 18px;
      display: flex;
      flex-direction: column;
      row-gap: 6px;
      li{
        color: #090909;
        font-family: 'Inter', sans-serif;
        font-size: 14px;
        line-height: 1.4;
        text-align: start;
      }
    }
  }
  .ai-summary-trigger{
    display: flex;
    flex-direction: column;
    row-gap: 12px;
    margin: 12px 0 20px 0;
  }
  .ai-summary{
    display: flex;
    flex-direction: column;
    row-gap: 10px;
    background: #EDF5F3;
    border-radius: 18px;
    padding: 16px 20px;
    box-sizing: border-box;
    p{
      color: #090909;
      font-family: 'Inter', sans-serif;
      font-size: 14px;
      line-height: 1.5;
      margin: 0;
      text-align: start;
    }
    &__close{
      align-self: flex-end;
      border: none;
      background: transparent;
      color: $fluxoo-primary-color;
      font-family: 'Inter', sans-serif;
      font-size: 13px;
      font-weight: 600;
      cursor: pointer;
      padding: 0;
    }
  }
  .ai-panel{
    width: 100%;
    display: flex;
    flex-direction: column;
    row-gap: 10px;
    background: #EDF5F3;
    border-radius: 18px;
    padding: 16px 20px;
    box-sizing: border-box;
    margin-bottom: 14px;
    label{
      color: #090909;
      font-family: 'Inter', sans-serif;
      font-size: 14px;
      font-weight: 600;
      text-align: start;
    }
    textarea{
      width: 100%;
      min-height: 70px;
      resize: vertical;
      border-radius: 14px;
      border: 1px solid #D3D3D3;
      color: #090909;
      font-family: 'Inter', sans-serif;
      font-size: 14px;
      padding: 12px 16px;
      box-sizing: border-box;
      &:focus{
        outline: none;
        border-color: $fluxoo-primary-color;
      }
      &::placeholder{
        color: #949494;
      }
    }
    &__footer{
      display: flex;
      align-items: center;
      justify-content: space-between;
      column-gap: 12px;
    }
    &__quota{
      color: #6F6F6F;
      font-family: 'Inter', sans-serif;
      font-size: 13px;
    }
    input[type="button"]{
      width: auto;
      height: 40px;
      min-height: unset;
      padding: 0 20px;
      border: none;
      border-radius: 30px;
      background: $fluxoo-primary-color;
      color: #FFF;
      font-family: 'Inter', sans-serif;
      font-size: 14px;
      font-weight: 600;
      cursor: pointer;
      transition: background .2s;
      &:disabled{
        background: #D3D3D3 !important;
        cursor: not-allowed;
      }
      &:hover:not(:disabled){
        background: $fluxoo-primary-color-hover;
      }
    }
  }

  @media(max-width: 768px){
    #create-documents{
      nav{
        padding: 15px;
      }
    }
  }

  @media(max-width: 425px){
    #create-documents{
      padding: 25px 0 120px 0;
      nav{
        animation: enterToBottom ease 0.9s;
        width: 100vw;
        position: fixed;
        left: 0;
        bottom: 0;
        border-radius: 20px 20px 0px 0px;
        background: #FFF;
        box-shadow: 0px 0px 25px 0px rgba(0, 0, 0, 0.12);
        padding: 15px;
        box-sizing: border-box;
        z-index: 4;
      }
      .modal {
        padding: unset;
        &.date-limit{
          padding: 0 10px;
          .modal__content{
            border-radius: 28px;
            padding: 15px;
            .date-picker{
              .select-day{
                .date{
                  gap: 0;
                }
              }
            }
          }
        }
        &.confirm-create-document{
          padding: 0 15px;
          .modal__content{
            border-radius: 28px;
            bottom: unset;
            left: unset;
            right: unset;
            top: 0;
            opacity: 0;
            transition: all 0.2s ease-out;
            &.closed {
                opacity: 0;
                transform: translateY(-110%) !important;
            }
            &.open {
                opacity: 1;
                transform: translateY(0) !important;
            }
          }
        }
      }
    }
  }
</style>
